// Componente para manejar una única dirección
import {
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography
} from "@mui/material";
import TextField from "@mui/material/TextField";
import DeleteIcon from "@mui/icons-material/Delete";
import FormControl from "@mui/material/FormControl";

const AddressForm = ({address, index, onChange, onRemove, canRemove, isReadOnly, addressSize, countries = []}) => {

  const selectedCountry = countries.find(c => c.id === address.countryId);
  const states = selectedCountry?.states || [];
  const shouldDisableStateSelect = !address.countryId || states.length === 0;

  const handleAddressChange = (e) => {
    const {name, value, type, checked} = e.target;
    const newValue = type === 'checkbox' ? checked : value;
    onChange(index, name, newValue);
  };

  const handleCountryChange = (event) => {
    const newCountryValue = event.target.value;
    onChange(index, "countryId", newCountryValue);
    onChange(index, "stateProvinceId", "");
  };

  return (
    <Paper elevation={1} sx={{p: 2, mt: 3}}>
      <Grid container spacing={2}>
        <Grid item xs={12} sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          <Typography variant="h6">
            Address #{index + 1}
          </Typography>
          {canRemove && (
            <IconButton
              onClick={() => onRemove(index)}
              color="error"
              size="small"
              disabled={isReadOnly}
              aria-label={`Delete address ${index + 1}`}
            >
              <DeleteIcon/>
            </IconButton>
          )}
        </Grid>

        {/* --- Primera Línea de Dirección --- */}
        <Grid item xs={12}>
          <TextField
            margin="dense"
            name="streetAddress1"
            label="Address line 1"
            fullWidth
            inputProps={{
              readOnly: isReadOnly,
            }}
            value={address.streetAddress1 ?? ''}
            onChange={handleAddressChange}
            required
          />
        </Grid>

        {/* --- Segunda Línea de Dirección --- */}
        <Grid item xs={12}>
          <TextField
            margin="dense"
            name="streetAddress2"
            label="Adress line 2 (Optional)"
            fullWidth
            inputProps={{
              readOnly: isReadOnly,
            }}
            value={address.streetAddress2 ?? ''}
            onChange={handleAddressChange}
          />
        </Grid>

        {/* --- Provincia/Estado y País --- */}
        <Grid item xs={12} sm={6}>
          <FormControl
            margin="dense"
            fullWidth
            required
          >
            <InputLabel id="country-label">Country</InputLabel>
            <Select
              labelId="country-label"
              id="countryId"
              name="countryId"
              value={address.countryId ?? ''}
              label="Country"
              required
              readOnly={isReadOnly}
              onChange={handleCountryChange}
            >
              {countries.map(country => (
                <MenuItem
                  key={country.id}
                  value={country.id}
                >
                  {country.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl
            margin="dense"
            fullWidth
            disabled={shouldDisableStateSelect}
          >
            <InputLabel id="stateProvince-label">Province/State (Optional)</InputLabel>
            <Select
              labelId="stateProvince-label"
              id="stateProvinceId"
              name="stateProvinceId"
              value={address.stateProvinceId ?? ''}
              label="Province/State (Optional)"
              readOnly={isReadOnly}
              onChange={handleAddressChange}
            >
              {states.map(state => (
                <MenuItem
                  key={state.id}
                  value={state.id}
                >
                  {state.name}
                </MenuItem>
              ))}

              {shouldDisableStateSelect && (
                <MenuItem disabled value="">
                  No provinces/states registered
                </MenuItem>
              )}
            </Select>
          </FormControl>
        </Grid>

        {/* --- Ciudad y Código Postal --- */}
        <Grid item xs={12} sm={6}>
          <TextField
            margin="dense"
            name="city"
            label="City"
            fullWidth
            inputProps={{
              readOnly: isReadOnly,
            }}
            value={address.city ?? ''}
            onChange={handleAddressChange}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            margin="dense"
            label="Postal code"
            name="postalCode"
            fullWidth
            inputProps={{
              readOnly: isReadOnly,
            }}
            value={address.postalCode ?? ''}
            onChange={handleAddressChange}
            required
          />
        </Grid>


        {/* --- Checkbox de Facturación --- */}
        <Grid item xs={12}
              sx={{ display: addressSize !== 1 ? 'block' : 'none' }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={!!address.isBilling}
                onChange={handleAddressChange}
                name="isBilling"
                color="primary"
                disabled={isReadOnly}
              />
            }
            label="Billing address?"
          />
        </Grid>

      </Grid>
    </Paper>
  );
};

export default AddressForm;
